import Http from "../../../../../core/http-axios-react/http/Http";
import { HttpBaseResponse, HttpData } from "../../../../../core/HttpResponse";
import { M_Brand } from "../../../type/Produk.type";

export const getBrands = async (
  { keyword, page }: { keyword?: string; page: number } = {
    page: 1,
  }
) => {
  const result = await Http.get<HttpBaseResponse<HttpData<M_Brand[]>>>({
    url: "/product/brand",
    params: {
      keyword,
      page,
    },
  });
  return result;
};

export const getBrand = async ({
  product_brand_id,
}: {
  product_brand_id?: string;
}) => {
  const result = await Http.get<HttpBaseResponse<M_Brand>>({
    url: "/product/brand/detail",
    params: {
      product_brand_id,
    },
  });
  return result;
};

export const addBrand = async ({ brand_name }: { brand_name: string }) => {
  const result = await Http.post({
    url: "/product/brand/insert",
    data: {
      brand_name,
    },
  });
  return result;
};

export const updateBrand = async ({
  product_brand_id,
  brand_name,
}: {
  product_brand_id: string;
  brand_name: string;
}) => {
  const result = await Http.post({
    url: "/product/brand/update",
    data: {
      product_brand_id,
      brand_name,
    },
  });
  return result;
};

export const importBrand = async ({ file }: { file: File }) => {
  const results = await Http.post({
    url: "/product/brand/import",
    data: {
      file,
    },
  });
  return results;
};
